module.exports = __webpack_public_path__ + "static/media/sus-icon.6e2b4709.png";